import { Language } from "@cak-legacy/shared-locales";
import { ClientService } from "@cak-legacy/cms-iprox";

import { IFormContentDataViewModel } from "../interface/formContentData";
import { FormContentResponseMapper } from "../mapper/FormContentResponseMapper";

export class FormulierenContentService extends ClientService {
  constructor(protected readonly baseUrl: string) {
    super(baseUrl + "/formulierencontent");
  }

  getSpecificCmsContent = async (
    formAlias: string,
    language: Language
  ): Promise<IFormContentDataViewModel> => {
    try {
      const response = await this.client.contentFormsForm(formAlias, language);
      return FormContentResponseMapper.map(response);
    } catch (error) {
      const message = ClientService.getErrorMessage(error);
      return Promise.reject(new Error(message));
    }
  };

  getGenericCmsContent = async (language: Language): Promise<IFormContentDataViewModel> => {
    try {
      const response = await this.client.contentFormsGenericForm("all-forms", language);
      return FormContentResponseMapper.map(response);
    } catch (error) {
      const message = ClientService.getErrorMessage(error);
      return Promise.reject(new Error(message));
    }
  };
}
